import { useState } from 'react'
import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import moment from 'moment';

const InlineUploadFileInput = ({ save, value, onChange, ...props }) => {
  const [uploading, setUploading] = useState(false)
  const [wvrFileId, setWvrFileId] = useState(null)

  const parseChangedValue = ({ file, fileList }) => {
    fileList[0].wvrFileId = wvrFileId
    file.wvrFileId = wvrFileId
    return onChange({ file, fileList })
  }

  const createWeaverFile = async (file) => {
    try {
      file.uploadTime = moment()
      const wvrFile = new Weaver.File(file)
      await wvrFile.upload()
      setWvrFileId(wvrFile.id())
    } catch (e) {
      console.error(e.message)
    }
  }

  return (
    <Upload
      style={{ width: '100%' }}
      action={null}
      beforeUpload={async (file) => {
        setUploading(true)
        await createWeaverFile(file)
        setUploading(false)
        return false
      }}
      showUploadList={{
        showPreviewIcon: false,
        showRemoveIcon: false,
        showDownloadIcon: false,
        removeIcon: false,
        downloadIcon: false
      }}
      maxCount={1}
      multiple={false}
      onChange={parseChangedValue}
      {...props}
    >
      <Button
        style={{ width: '100%' }}
        icon={<UploadOutlined />}
        disabled={uploading}
      >
        { uploading ? 'Uploading file. Please wait...' : 'Click to upload file' }
      </Button>
    </Upload>
  )
}

export default InlineUploadFileInput
